export const AbilityStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: 'fit-content',
    gap: '5px',
    borderRadius: '10px',
    padding: '10px',
    backgroundColor: '#14A06F'
}
export const listAbility = {
    display: 'flex',
    gap: '5px'
}